import * as types from './types'
import { getCookie } from '@/utils/util'
import * as financialApi from '@/apis/financial'




export const setUserInfo = ({ commit, state }) => {
  commit(types.SET_USER_INFO, getCookie().userInfo)
}
export const setDownloadNum = ({ commit, state },data) => {
  console.log(data,'statestate')
  commit(types.SET_DOWNLOAD_NUM, data)
}



export const setBalance = async ({ commit, state }) => {
  const data = await getBalance()
  commit(types.SET_BALANCE, data)
}

const getBalance = async () => {
  const result1 = await financialApi.getVisaBalance()
  const result2 = await financialApi.getWalletBalance()
  const result3 = await financialApi.getMallBalance()
  let balance = {}
  if (result1) {
    balance = {
      ...balance,
      ...result1
    }
  }
  if (result2) {
    balance = {
      ...balance,
      insuranceBalance: result2.balance
    }
  }
  if (result3) {
    balance = {
      ...balance,
      mallBalance: result3.balance
    }
  }
  return balance
}
